import {
  buildProfileArtworksUrl,
  downloadQrPng,
  resolveQrBaseUrl,
  sanitizeQrFilePart,
} from '@/utils/qrCode.utils';

export { downloadQrPng };

export function buildGalleryQrFilename(session, extension = 'png') {
  const username = sanitizeQrFilePart(session?.user_username);
  const name = sanitizeQrFilePart(session?.user_name);
  const fallback = sanitizeQrFilePart(session?._id) || 'gallery';
  return `suarte-gallery-qr-${username || name || fallback}.${extension}`;
}

export function normalizeGalleryQrPayload(session) {
  const qr = session?.gallery_qr;
  const token = typeof qr?.token === 'string' ? qr.token.trim() : '';
  if (!token) {
    return null;
  }

  const baseUrl = resolveQrBaseUrl();
  const username = typeof session?.user_username === 'string' ? session.user_username.trim() : '';

  return {
    token,
    qrUrl: qr.qrUrl || `${baseUrl}/q/gallery/${encodeURIComponent(token)}`,
    targetUrl: qr.targetUrl || buildProfileArtworksUrl(username, baseUrl),
    isActive: qr.isActive,
    fallbackUrl: qr.fallbackUrl || baseUrl,
    createdAt: qr.created_at || qr.createdAt || null,
    createdByGalleryId: qr.created_by_gallery_id || qr.createdByGalleryId || null,
  };
}
